import { Helmet } from 'react-helmet';
import * as S from './About.styles';
const About = () => {
  return (
    <S.Container>
      <Helmet>
        <title>Uplus Education - About</title>
        <meta name="description" content="Learn more about Uplus Education, our team and campuses." />
      </Helmet>
      <S.Title>About Uplus Education</S.Title>
      <S.Section>
        <h2>Education Concepts</h2>
        <S.Highlight>UPLIFT | PERSEVERE | LEAD | UNDERSTAND | SUPPORT</S.Highlight>
        <S.Quote>
          "AT UPLUS EDUCATION, WE BELIEVE THAT LEARNING IS MORE THAN JUST PUSHING FOR ACADEMIC SUCCESS AND PRODUCING STRAIGHT A STUDENTS. INSTEAD, WE PRIORITISE THE ABILITY TO 'LEARN HOW TO LEARN' AND WORK WITH PARENTS TO INSTILL A SENSE OF PATIENCE, PERSEVERANCE AND CONFIDENCE IN EACH AND EVERY CHILD"
        </S.Quote>
      </S.Section>

      {/* 以下为从 Home.js 移动过来的内容 */}
      <section>
        <h2>The Origin of Uplus Education</h2>
        <p>The current name and logo of Uplus Education have been in use since 2008.</p>
        <p>Influenced by both Chinese and Western cultures, Ms. Lu embraces the Western "student-centered" teaching philosophy and believes that growth is a process of continuous accumulation, cycling outward, and breaking through oneself layer by layer.</p>
        <p>The English word "you" sounds similar to the Chinese character "优" (excellence), and "加" (jia) can be understood not only as addition but also as rising and growth. Hence, the logo was designed as a spiral extending outward with the letter "U" at its center.</p>
        <p>Uplus Education aims to be more than just a tutoring center focused on academics; it strives to be an institution that cares about students' education and growth in multiple dimensions, thus adopting the name Uplus Education.</p>
      </section>

      <section>
        <h2>Announcements</h2>
        <p>Coming soon...</p>
      </section>
    </S.Container>
  );
};

export default About;